import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252fbabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-detail__name-redirect" }
const _hoisted_2 = { class: "product_name" }
const _hoisted_3 = { class: "links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'bag' },
        class: "product-detail__link-bag"
      }),
      _createVNode(_component_router_link, {
        to: { name: 'favorite' },
        class: "shop__favorite"
      })
    ])
  ]))
}